export const baseUrl = "https://api.baran-academy.ir";
// export const baseUrl = "http://192.168.10.112:8000";
